import { Loadable } from 'jotai/vanilla/utils/loadable'
import { ExtractionData } from 'ContractExtraction/atoms'

export const getSequenceRequestId = (
  extractionResult: Loadable<Promise<ExtractionData | null> | null>
) => {
  switch (extractionResult.state) {
    case 'loading':
      return null
    case 'hasError':
      return (extractionResult.error as Error).message.split(' ').at(-1)
    case 'hasData':
      return extractionResult.data?.sequenceRequestId
  }
}
